//chart
import Histogram from "assets/images/chart-images/histogram.png";

const numberOfReviewersInvitedPerManuscripts = [
    // Time from editor assignment to first reviewer invited-none
    { id: "#E#I-H01e", name: "histogram", chartImage: Histogram, disabled: false },
    { id: "#E#I-H01s", name: "histogram", chartImage: Histogram, disabled: false },
    
];

export default numberOfReviewersInvitedPerManuscripts;
